import { IEquipmentSearchParams, TEquipmentFormData } from 'src/@types';
import { IAttachment, IEquipment, IEquipmentDashboard } from 'src/@types/apiResponseTypes';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/v1/equipment';

/**
 * Equipment 목록 조회
 * @param params 검색 조건
 */
export const gets = async (params?: IEquipmentSearchParams) => {
  try {
    const url = SUB_URL;
    const response = await instance.get<TApiResponseData<IEquipment[]>>(url, {
      params,
    });

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Equipment 단건 조회
 * @param equipmentSid Equipment 고유번호
 */
export const get = async (equipmentSid: number) => {
  try {
    const url = `${SUB_URL}/${equipmentSid}`;
    const response = await instance.get<TApiResponseData<IEquipment>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Equipment 등록
 * @param formData Equipment 등록 정보: TEquipmentFormData
 */
export const create = async (formData: TEquipmentFormData) => {
  try {
    const url = SUB_URL;

    const form = new FormData();

    // 파일 추가
    formData?.files?.forEach((file) => {
      if (file instanceof File) {
        form.append('files', file);
      }
    });

    const excludes = ['files'];

    (Object.keys(formData) as Array<keyof TEquipmentFormData>).forEach((key) => {
      // 값이 있는 경우에만 append
      if (!excludes.includes(key)) {
        form.append(key, formData[key] as string);
      }
    });

    const response = await instance.post<TApiResponseData<IEquipment>>(url, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Equipment 정보 수정
 * @param equipmentSid Equipment 고유번호
 * @param formData Equipment 등록 정보: TEquipmentFormData
 */
export const update = async (equipmentSid: number, formData: TEquipmentFormData) => {
  try {
    const url = `${SUB_URL}/${equipmentSid}`;

    const form = new FormData();

    // 파일 추가
    formData?.files?.forEach((file) => {
      if (file instanceof File) {
        form.append('files', file);
      }
    });

    const excludes = ['files'];

    (Object.keys(formData) as Array<keyof TEquipmentFormData>).forEach((key) => {
      // 값이 있는 경우에만 append
      if (!excludes.includes(key)) {
        form.append(key, formData[key] as string);
      }
    });

    const response = await instance.put<TApiResponseData<IEquipment>>(url, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Equipment 삭제
 * @param equipmentSid Equipment 고유번호
 */
export const remove = async (equipmentSid: number) => {
  try {
    const url = `${SUB_URL}/${equipmentSid}`;
    const response = await instance.delete<TApiResponseData<boolean>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      // 삭제 성공 시 true 반환
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 보고서 첨부파일 삭제
 * attachment: IAttachment
 */
export const deleteFile = async (attachment: IAttachment) => {
  try {
    const url = `${SUB_URL}/${attachment.equipmentSid}/file/${attachment.fileSid}`;
    const response = await instance.delete<TApiResponseData<any>>(url);

    if (response.data.resultCode === 'S') {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 장비 현황 조회
 */
export const getEquipmentDashboard = async () => {
  try {
    const url = `${SUB_URL}/dashboard`;

    const response = await instance.get<TApiResponseData<IEquipmentDashboard>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S') {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
